import { render } from "./regalos.vue?vue&type=template&id=439966db&scoped=true"
import script from "./regalos.vue?vue&type=script&lang=js"
export * from "./regalos.vue?vue&type=script&lang=js"

import "./regalos.vue?vue&type=style&index=0&id=439966db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439966db"]])

export default __exports__